<script lang="ts" setup>
useSeo({
  title: `Search & Explore Podcasts and Radio Stations`,
  description: `Zeno.FM is your go-to platform to discover and enjoy podcasts and streaming radio stations from around the world. We specialize in international content, featuring shows and stations from Brazil, Mexico, Colombia, Haiti, Argentina, Ghana, Peru, Guatemala, Spain, and many more!`,
})

const hasFilters = computed(() => Object.keys(useRoute().query).length > 0)
</script>

<template>
  <div class="md:space-y-12 space-y-6">
    <PageTitle>Explore</PageTitle>

    <SearchInput />

    <ExploreNavigation />

    <template v-if="!hasFilters">
      <ExploreTrendingSearches />

      <section class="space-y-5">
        <SectionTitle>Search by</SectionTitle>
        <div class="grid grid-cols-3 gap-2 md:text-3xl sm:text-2xl text-lg uppercase font-monigue text-center">
          <NuxtLink :to="{ name: 'radio-genres' }" class="bg-zeno-gray-light rounded-2xl sm:p-4 p-2"> Genre</NuxtLink>
          <NuxtLink :to="{ name: 'radio-countries' }" class="bg-zeno-gray-light rounded-2xl sm:p-4 p-2">
            Location
          </NuxtLink>
          <NuxtLink :to="{ name: 'radio-languages' }" class="bg-zeno-gray-light rounded-2xl sm:p-4 p-2">
            Language
          </NuxtLink>
        </div>
      </section>

      <StationsLocal />

      <StationsTrending />

      <StationsTop />

      <PodcastsLocal />

      <PodcastsTop />
    </template>

    <template v-else>
      <StationsResults v-if="hasFilters" />

      <PodcastsResults v-if="hasFilters" />
    </template>
  </div>
</template>

<style scoped></style>
